import React, {useState, useCallback, useEffect, useRef} from 'react';
import {
    Flex, Text, Tabs, TabList, TabPanels, Tab, TabPanel, Box, Button
} from "@chakra-ui/react";
import L from "leaflet"
import axios from "axios";
import ENV from "../ENV.json";
import {useHistory} from "react-router-dom";
import DimensioneMap from "./DimensioneMap";
import Popup from "./Popup";
import {LayersControl, MapContainer, Marker, TileLayer, useMap, useMapEvents} from "react-leaflet";
//import "leaflet/dist/leaflet.css";
import MaterialTable from 'material-table'
import "leaflet-geosearch/dist/geosearch.css";
import {GeoSearchControl, OpenStreetMapProvider} from "leaflet-geosearch";
import DialogChoose from "./DialogChoose";
import MapLayerControl from "./MapLayerControl"
import MapLegend from "./MapLegend";
import './SearcherPoi.css'

axios.defaults.withCredentials = true; //Cookie session

const SearcherPOI = (props) => {

    //NAVIGATION
    const history = useHistory();

    //POPUPS STATE
    const [modalOpen, setModalOpen] = useState(false);
    const [popupData, setPopupData] = useState({});

    //Punti di interesse e il loro caricamento
    const [isPoiDownloading, setIsPoiDownloading] = useState(false);
    const [pois, setPois] = useState([]);

    //Punti di interesse salvati
    const [isPoiTempDownloading, setIsPoiTempDownloading] = useState(false);
    const [temp_pois, setTempPois] = useState([]);

    //Stati per il popup della cancellazione dei temp poi.
    const [titlePopupTemp, setTitlePopupTemp] = useState(null);
    const [messagePopupTemp, setMessagePopupTemp] = useState(null);
    const [isPopupOpenTemp, setIsPopupOpenTemp] = useState(false);
    const [dismissTextTemp, setDismissTextTemp] = useState(null);
    const [acceptTextTemp, setAcceptTextTemp] = useState(null);
    //Stati per il popup della cancellazione dei poi.
    const [titlePopup, setTitlePopup] = useState(null);
    const [messagePopup, setMessagePopup] = useState(null);
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [dismissText, setDismissText] = useState(null);
    const [acceptText, setAcceptText] = useState(null);

    //Carica i dati nel momento della visualizzazione della pagina
    useEffect(() => {
        loadPoi();
        loadTempPoi();
    }, [])

    //Callback per ottenere tutti i poi.
    const loadPoi = useCallback(() => {
        setIsPoiDownloading(true);
        axios.get(`${ENV[ENV.ENV_STATE].baseUrl}/get/all/poi`)
            .then(function (response) {
                if (response?.data?.status) {

                    delete response?.data?.meta;

                    setPois(response?.data?.rows);
                } else {
                    setPopupData(response?.data)
                    setModalOpen(true);
                }
            })
            .catch(function (error) {
                setPopupData({
                    status: false,
                    title: "Errore imprevisto",
                    message: "Non è stato possibile caricare i punti di interesse"
                })
                setModalOpen(true);
                if (error.response.status === 403) {
                    logout();
                }
            })
            .then(function (response) {
                setIsPoiDownloading(false)
            });
    }, []);
    //Callback per ottenere tutti i poi temporanei.
    const loadTempPoi = useCallback(() => {
        setIsPoiTempDownloading(true)
        axios.get(`${ENV[ENV.ENV_STATE].baseUrl}/get/all/poi/temp`)
            .then(function (response) {
                if (response?.data?.status) {

                    delete response?.data?.meta;

                    setTempPois(response?.data?.result);
                } else {
                    setPopupData(response?.data)
                    setModalOpen(true);
                }
            })
            .catch(function (error) {
                setPopupData({
                    status: false,
                    title: "Errore imprevisto",
                    message: "Non è stato possibile caricare i punti di interesse salvati"
                })
                setModalOpen(true);
                if (error.response.status === 403) {
                    logout();
                }
            })
            .then(function (response) {
                setIsPoiTempDownloading(false)
            });
    }, []);
    //Effettua la logout
    const logout = useCallback(() => history.push('/'), [history]);

    //Valore del campo di ricerca dei punti di interesse
    const [search, setSearch] = useState("");

    //Callback di quando si clicca su un punto di interesse inserito in piattaforma
    const onListItemClick = useCallback((ID) => {
        if (props?.onSelectedPoi) {
            props?.onSelectedPoi(ID);
        }
    }, []);
    //Callback di quando si clicca sul punto di interesse salvato nel database
    const onListTempItemClick = useCallback((_id) => {
        if (props?.onSelectedTempPoi) {
            props?.onSelectedTempPoi(_id);
        }
    }, []);
    //Questa callback elimina un punto di interesse con id = _id (può essere usata sia per mongo che per mysql
    const [_id, set_Id] = useState(null); //Mongo _id preparato per la cancellazione
    const [ID, setID] = useState(null) //SQL ID preparato per la cancellazione

    //Questa funzione cancella un poi temporaneo
    const deleteTempPoi = useCallback(() => {
        setIsPoiTempDownloading(true)
        axios.post(`${ENV[ENV.ENV_STATE].baseUrl}/delete/poi/temp`, {"__id": _id})
            .then(function (response) {
                if (response?.data?.status) {
                    setPopupData(response?.data)
                    setModalOpen(true);
                    set_Id(null); //C-Cleaner
                    loadTempPoi();
                } else {
                    setPopupData(response?.data)
                    setModalOpen(true);
                }
            })
            .catch(function (error) {
                setPopupData({
                    status: false,
                    title: "Errore imprevisto",
                    message: "Non è stato possibile caricare i punti di interesse salvati"
                })
                setModalOpen(true);
                if (error?.response?.status === 403) {
                    logout();
                }
            })
            .then(function (response) {
                setIsPoiTempDownloading(false)
            });
    }, [_id]);
    //Questa funzione cancella un poi non temporaneo
    const deletePoi = useCallback(() => {
        setIsPoiTempDownloading(true);
        axios.post(`${ENV[ENV.ENV_STATE].baseUrl}/delete/poi`, {"__id": `${ID}`})
            .then(function (response) {
                if (response?.data?.status) {
                    setPopupData(response?.data)
                    setModalOpen(true);
                    setID(null); //C-Cleaner
                    loadPoi();
                } else {
                    setPopupData(response?.data)
                    setModalOpen(true);
                }
            })
            .catch(function (error) {
                setPopupData({
                    status: false,
                    title: "Errore imprevisto",
                    message: "Non è stato possibile caricare i punti di interesse"
                })
                setModalOpen(true);
                if (error?.response?.status === 403) {
                    logout();
                }
            })
            .then(function (response) {
                setIsPoiTempDownloading(false);
            });
    }, [ID]);

    //MAPPA
    const [zoom, setZoom] = useState(5);
    const markerRef = useRef(null);

    //La mappa è visibile o meno?
    const [isMapVisible, setIsMapVisible] = useState(false);

    //Componente per la ricerca
    function LeafletgeoSearch() {
        const map = useMap();
        useEffect(() => {
            const provider = new OpenStreetMapProvider();
            const searchControl = new GeoSearchControl({
                provider,
                showMarker: false,
                /*marker: {
                    icon
                }*/
            });
            map.addControl(searchControl);
            return () => map.removeControl(searchControl);
        }, []);
        return null;
    }

    function GetTempIcon(_iconSize, name) {
        return L.icon({
            iconUrl: require(`../${name}`),
            iconSize: [_iconSize]
        })
    }

    function MarkerCustom(props) {

        return props?.data?.position === null ? null : (
            <Marker
                icon={GetTempIcon(props?.size, props?.name)}
                draggable={props?.data?.draggable}
                position={{lat: props?.data?.position?.lat, lng: props?.data?.position?.lng}}
                eventHandlers={{
                    click: (e) => {
                        //console.log(`Cliccato ${props?.data?.title}`)
                        if (props?.onClick) props?.onClick(props?.data?.ID);
                    },
                }}
            >
                <Popup>{props?.data?.title}</Popup>
            </Marker>
        )
    }


    return (
        <Flex className={"searcher_container"}>
            <Text fontWeight="bold">SEZIONE DI RICERCA DI PUNTI DI INTERESSE INSERITI</Text>
            <Flex flexDirection="column" width="100%" gap='10px'>
                <Flex flexDirection="column" flex='1' padding="10px" gap='10px'>
                    <div style={{maxWidth: '100%'}}>
                        <Tabs>
                            <TabList>
                                <Tab onClick={() => loadTempPoi()}>SALVATI</Tab>
                                <Tab onClick={() => loadPoi()}>CARICATI</Tab>
                            </TabList>

                            <TabPanels>
                                <TabPanel>
                                    <MaterialTable
                                        isLoading={isPoiTempDownloading}
                                        actions={[
                                            {
                                                icon: 'delete',
                                                tooltip: 'Elimina punto di interesse salvato!',
                                                onClick: (event, rowData) => {
                                                    //Settare i dati del popup ed aprirlo
                                                    setTitlePopupTemp(`Desideri eliminare il punto "${rowData?.title}"`)
                                                    setMessagePopupTemp(`Stai per eliminare il punto di interesse ${rowData?.title}\nID=${rowData?._id}`)
                                                    setDismissTextTemp("Non cancellare!");
                                                    setAcceptTextTemp("Si, cancella ora!");
                                                    setIsPopupOpenTemp(true);
                                                    set_Id(rowData?._id);
                                                    //deleteTempPoi(rowData?._id);
                                                }
                                            },
                                            {
                                                icon: 'edit',
                                                tooltip: 'Modifica punto di interesse salvato',
                                                onClick: (event, rowData) => {
                                                    onListTempItemClick(rowData?._id);
                                                }
                                            },
                                        ]}
                                        columns={[
                                            {title: 'ID', field: '_id'},
                                            {title: 'Titolo', field: 'title'},
                                            {title: 'Indirizzo', field: 'address'},
                                        ]}
                                        data={temp_pois}
                                        title="Punti di interesse salvati (non caricati online)"
                                    />
                                </TabPanel>
                                <TabPanel>
                                    <MaterialTable
                                        isLoading={isPoiDownloading}
                                        actions={[
                                            {
                                                icon: 'delete',
                                                tooltip: 'Elimina punto di interesse!',
                                                onClick: (event, rowData) => {
                                                    //Eliminare rowData?.ID
                                                    //set_Id(rowData?.ID);
                                                    setTitlePopup(`Desideri eliminare il punto "${rowData?.title || "di interesse"}"`)
                                                    setMessagePopup(`Stai per eliminare il punto di interesse ${rowData?.title || ""}\nID=${rowData?.ID}`)
                                                    setDismissText("Non cancellare!");
                                                    setAcceptText("Si, cancella ora!");
                                                    setIsPopupOpen(true);
                                                    setID(rowData?.ID);
                                                }
                                            },
                                            {
                                                icon: 'edit',
                                                tooltip: 'Modifica punto di interesse',
                                                onClick: (event, rowData) => {
                                                    onListItemClick(rowData?.ID);
                                                }
                                            },
                                        ]}
                                        columns={[
                                            {title: 'ID', field: 'ID'},
                                            {title: 'Titolo', field: 'title'},
                                            {title: 'Indirizzo', field: 'address'},
                                        ]}
                                        data={pois}
                                        title="Punti di interesse già online"
                                    />
                                </TabPanel>
                            </TabPanels>
                        </Tabs>
                    </div>
                </Flex>
                <Button
                    fontWeight ={"600"}
                    boxShadow = {" rgb(38, 57, 77) 0px 2px 3px 1px"}
                    onClick = {()=>{setIsMapVisible(prevState => !prevState)}}
                >
                    {`${isMapVisible ? "Nascondi mappa" : "Mostra mappa"}`}
                </Button>
                {
                    isMapVisible &&
                    <Flex flexDirection={"column"} flex='3' padding="10px" maxHeight="500px">
                        <Text>Tutti i punti di interesse aggiunti</Text>
                        <MapLegend isTemp isAdded isEdit/>
                        <Box marginTop={"20px"}/>
                        <MapContainer
                            center={{lat: 51.58720632067826, lng: 25.672857055984474}}
                            zoom={zoom}
                            scrollWheelZoom={true}
                            style={{height: "100vh"}}
                        >
                            <LayersControl position="topright">
                                <MapLayerControl/>
                                {
                                    pois && pois.map(elem => (
                                        <MarkerCustom
                                            size={32}
                                            name="GPS_SAVED.png"
                                            key={elem?.ID}
                                            data={{
                                                ID: elem?.ID,
                                                draggable: false,
                                                position: {lat: elem?.lat, lng: elem?.longitude},
                                                title: elem?.title
                                            }}
                                            onClick={(ID) => {
                                                if (props?.onSelectedPoi) props?.onSelectedPoi(ID);
                                            }}
                                        />
                                    ))
                                }
                                {
                                    temp_pois && temp_pois.map(elem =>
                                        <MarkerCustom
                                            size={32}
                                            name="GPS_TEMP.png"
                                            key={elem?._id}
                                            data={{
                                                ID: elem?._id,
                                                draggable: false,
                                                position: {lat: elem?.LAT.toString(), lng: elem?.LONG.toString()},
                                                title: elem?.title
                                            }}
                                            onClick={(ID) => {
                                                if (props?.onSelectedTempPoi) props?.onSelectedTempPoi(ID);
                                            }}
                                        />
                                    )
                                }
                                <LeafletgeoSearch/>
                            </LayersControl>
                        </MapContainer>
                    </Flex>
                }
                <Popup isOpen={modalOpen} onClose={() => setModalOpen(false)} popupData={popupData}/>
            </Flex>
            <DialogChoose
                isOpen={isPopupOpenTemp}
                onClose={() => {
                    setIsPopupOpenTemp(false);
                }}
                title={titlePopupTemp}
                message={messagePopupTemp}
                dismissText={dismissTextTemp}
                acceptText={acceptTextTemp}
                onAccept={() => {
                    //Potenzialmente si deve cancellare il punto di interesse
                    deleteTempPoi();
                    //console.log("E' stato scelto di cancellare");
                }}
                onDismiss={() => {
                    //Potenzialmente non si deve cancellare nada
                    //console.log("E' stato scelto di non cancellare");
                }}
            />
            <DialogChoose
                isOpen={isPopupOpen}
                onClose={() => {
                    setIsPopupOpen(false);
                }}
                title={titlePopup}
                message={messagePopup}
                dismissText={dismissText}
                acceptText={acceptText}
                onAccept={() => {
                    deletePoi();
                }}
                onDismiss={() => {
                    //Potenzialmente non si deve cancellare nada
                    //console.log("E' stato scelto di non cancellare il poi");
                }}
            />
        </Flex>
    )
}

export default SearcherPOI;
